import './ToolTipTitle.scss';
import React from 'react';
import Tooltip from '../Tooltip';
import { MdHelpOutline } from 'react-icons/md';
import AutoLinkText from '@atoms/AutoLinkText';

export interface IToolTipTitleProps {
    title?: string;
}

const ToolTipTitle: React.FC<IToolTipTitleProps> = ({ title }: IToolTipTitleProps) => {
    return title ? (
        <div className="field-wrapper-title">
            <Tooltip openDelay={100} background="black" position="bottom" maxWidth="40ch">
                <MdHelpOutline size="16" />
                <AutoLinkText text={title} />
            </Tooltip>
        </div>
    ) : (
        <></>
    );
};

export default ToolTipTitle;
